module.exports = __webpack_public_path__ + "media/svg-new/avatar-22 3-e5f9e9ea.svg";